import apiClient from "./client";
import type {
  StatisticsOverview,
  ExpiringLicense,
  TrendData,
  ApiResponse,
} from "@/types";

export async function getOverview(): Promise<ApiResponse<StatisticsOverview>> {
  const { data } = await apiClient.get("/statistics/overview");
  return data;
}

export async function getExpiring(): Promise<ApiResponse<ExpiringLicense[]>> {
  const { data } = await apiClient.get("/statistics/expiring");
  return data;
}

export async function getTrends(): Promise<ApiResponse<TrendData[]>> {
  const { data } = await apiClient.get("/statistics/trends");
  return data;
}
